/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

// import { useState } from 'react'
import { setSnackbarMessage } from "../data/store/reducers/composer";
import { useDispatch } from "react-redux";

const useSnackbar = () => {
    
    // const [message, setMessage] = useState('')
    const dispatch = useDispatch();
    
    const showSnackbar = (message) => {
        // setMessage(message)
        // console.log(`showSnackbar: ${message}`)
        dispatch(setSnackbarMessage(message));
    };
    
    return {
        // message,
        // setMessage,
        showSnackbar
    };
};

export { useSnackbar };
